import { render, staticRenderFns } from "./IcoHealth.vue?vue&type=template&id=0750bf4a&scoped=true"
import script from "./IcoHealth.vue?vue&type=script&lang=js"
export * from "./IcoHealth.vue?vue&type=script&lang=js"
import style0 from "./IcoHealth.vue?vue&type=style&index=0&id=0750bf4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0750bf4a",
  null
  
)

export default component.exports